module.exports = __webpack_public_path__ + "media/images/emblems/Curtilles-coat_of_arms-69c1c95cdf5a9df8f42d158224610cb6.svg";